import React from "react"
import { UserContext } from "../../../store/store"

export function SoundOff() {
  const [state] = React.useContext(UserContext)
  const colorVar = state.theme === "light" ? "--bs-body-color" : "--bs-light"
  return (
    <svg width="24" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={`var(${colorVar})`}
        d="M0 6h2v8H0zM2 5h2v10H2zM4 4h2v12H4zM6 3h2v14H6zM8 2h2v16H8zM10 1h2v18h-2zM12 0h2v20h-2z"
      />
      <path
        stroke={`var(${colorVar})`}
        d="m20.823 12.273-5.057-5.025M20.954 7.231l-5.025 5.057"
      />
    </svg>
  )
}

export function SoundOn() {
  const [state] = React.useContext(UserContext)
  const colorVar = state.theme === "light" ? "--bs-body-color" : "--bs-light"
  return (
    <svg width="24" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={`var(${colorVar})`}
        d="M0 6h2v8H0zM2 5h2v10H2zM4 4h2v12H4zM6 3h2v14H6zM8 2h2v16H8zM10 1h2v18h-2zM12 0h2v20h-2zM17 11h1v1h-1zM20 11h1v1h-1zM18 10h1v1h-1zM21 10h1v1h-1zM18 9h1v1h-1zM21 9h1v1h-1zM17 8h1v1h-1zM20 8h1v1h-1zM17 7h1v1h-1zM20 7h1v1h-1zM16 6h1v1h-1zM19 6h1v1h-1zM18 4h1v1h-1zM16 5h1v1h-1zM19 5h1v1h-1zM18 3h1v1h-1zM17 12h1v1h-1zM20 12h1v1h-1zM16 13h1v1h-1zM19 13h1v1h-1zM18 15h1v1h-1zM16 14h1v1h-1zM19 14h1v1h-1zM18 16h1v1h-1z"
      />
    </svg>
  )
}
